import styled from 'shared/utils/styled';
import Button from '@mui/material/Button';
import { circularProgressClasses } from '@mui/material/CircularProgress';

import { LoadingPosition } from './LoadingButton.type';

type ButtonAccessories = {
  loadingPosition: LoadingPosition;
};

export const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'loadingPosition',
})<ButtonAccessories>(({ loadingPosition }) => ({
  [`& .${circularProgressClasses.root}`]: {
    marginLeft: loadingPosition === 'end' ? 8 : 0,
    marginRight: loadingPosition === 'end' ? 0 : 8,
    color: 'inherit',
  },
}));
